import {Model} from "../decorators/model.decorator";
import {Column} from "../decorators/column.decorator";
import {BaseModel} from "./base.model";

@Model('locales')
export class Locale extends BaseModel {
  @Column()
  iso: string | undefined;
  @Column()
  iso3: string | undefined;
  @Column()
  default: boolean | undefined;
  @Column()
  languageName: string | undefined;

  getFlag(){
    return `https://purecatamphetamine.github.io/country-flag-icons/3x2/${this.iso}.svg`
  }

}
